<template>
  <div v-if="response.length">
    <b-card>
      <b-form-row>
        <b-col cols="12">
          <b-table striped hover :items="items" :fields="fields">
            <template v-slot:cell(Filename)="data">
              <b-link v-on:click="downloadFile(data)">{{ data.value }}</b-link>
            </template>
          </b-table>
        </b-col>
      </b-form-row>
      <b-form-row v-if="hasMore">
        <b-col cols="12">
          <b-button block variant="primary" v-on:click="$emit('loadMore')"
            >Load More</b-button
          >
        </b-col>
      </b-form-row>
    </b-card>
  </div>
</template>

<script>
import { getInstance } from "../../auth";
const PortalApi = require("@brightoncromwell/portal-api");
const rfqsApiInstance = new PortalApi.RfqsApi();
let defaultClient = PortalApi.ApiClient.instance;

export default {
  name: "files-results",

  data() {
    return {
      downloadFileBytes: null,
      fields: [
          'Filename',
          'Date'
      ]
    };
  },

  props: ["response", "hasMore"],

  computed: {
    items: function() {
      console.log(this.response);
      return this.response?.map((file_summary) => ({
        Filename: file_summary.file_name,
        Date: new Date(file_summary.upload_date).toLocaleDateString(),
        attachment_id: file_summary.attachment_id,
      }));
    },
  },

  methods: {
    base64ToArrayBuffer(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
    
    saveByteArray(fileName, byte) {
      console.log(byte);
      var blob = new Blob([byte]);
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    },

    downloadFile: async function(file_data) {
      const token = await this.getToken();

      let BearerAuth = defaultClient.authentications["BearerAuth"];
      BearerAuth.accessToken = token;

      let company_id = parseInt(this.$route.params.company_id); // Number |
      let file_id = parseInt(file_data.item.attachment_id); // Number |

      rfqsApiInstance.rfqsCompanyCompanyIdFilesFileIdGet(
        company_id,
        file_id,
        (error, data, response) => {
          if (error) {
            console.error(error);
          } else {
            console.log(data);
            let byteArray = this.base64ToArrayBuffer(data);
            this.saveByteArray(file_data.item.Filename, byteArray);
          }
        }
      );
    },


    // $auth isn't loaded in by the time the page tries to get the token, so we need to do some extra steps in order to wait
    getToken: async function() {
      return new Promise((resolve, reject) => {
        const instance = getInstance();
        if (instance.loading == false) {
          // Redirect if the user isn't authenticated
          if (!instance.isAuthenticated) {
            window.location.href = "/signin";
          }
          resolve(instance.getTokenSilently());
        } else {
          instance.$watch("loading", (loading) => {
            if (loading == false && instance.isAuthenticated) {
              instance
                .getTokenSilently()
                .then((authToken) => {
                  resolve(authToken);
                })
                .catch((error) => {
                  if (error == "login_required") {
                    window.location.href = "/signin";
                  }
                  reject(error);
                });
            }
            // Redirect if the user isn't authenticated
            else if (!instance.isAuthenticated) {
              window.location.href = "/signin";
            }
          });
        }
      });
    },
  },
};
</script>
